import { Component, OnInit, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { EventSearchParams } from '../event-search-params.model';
//import moment from 'moment-es6';
import { MomentService } from '../../../shared/moment/moment.service';

//import {NotificationService, DialogService, PagedResult, PagedSearch, DatagridService, UtilService} from '../../shared/index'; //app/shared/index barrel;

@Component({
  selector: 'wl-events-context-search-input',
  templateUrl: 'events-context-search-input.component.html',
  styleUrls: ['events-context-search-input.component.css'],
  //inputs: ['searchParams'],
  //providers: [EventsService, DatagridService],
    standalone: false
})
@Injectable()
export class EventsContextSearchComponent implements OnInit {
  @Input() searchParams: EventSearchParams;
  @Input() placeholderText: string;
  @Input() defaultSearchDateStart: string;
  @Input() defaultSearchDateEnd: string;
  @Output() searchParamsChange: EventEmitter<EventSearchParams> = new EventEmitter<EventSearchParams>();
  public contextualSearchString: string;
  private _momentService: MomentService;

  public _timeoutId: number;

  public constructor(momentService: MomentService) {
    this._momentService = momentService;
  }

  ngOnInit() {
    this._timeoutId = 0;
    if (!this.searchParams) this.searchParams = new EventSearchParams();
  }

  public inputChanged(event: any) {
    clearTimeout(this._timeoutId);

    this._timeoutId = window.setTimeout(() => {
      this.searchParams = this.stringToEventSearchParamsButThatsOkay(this.contextualSearchString);
      this.searchParamsChange.emit(this.searchParams);
    }, 3000);
  }

  public stringToEventSearchParamsButThatsOkay(parseSource: string): EventSearchParams {
    var target = new EventSearchParams();
    // var intPattern = /^\s*\d\s*$/;
    var fromDatePattern = /from:\s*([^\s]+)/i;
    var toDatePattern = /to:\s*([^\s]+)/i;

    // set event id param
    if (Number(parseSource.trim())) {
      target.EventId = Number(parseSource.trim());
      parseSource = '';
    }

    // set date params
    if (fromDatePattern.test(parseSource)) {
      var fromString = fromDatePattern.exec(parseSource)[1];
      parseSource = parseSource.replace(fromDatePattern, '');
      if (Date.parse(fromString))
        target.SearchDateBegin = this._momentService
          .getMomentByDate(new Date(fromString))
          .startOf('day')
          .toDate();
    }
    if (toDatePattern.test(parseSource)) {
      var fromString = toDatePattern.exec(parseSource)[1];
      parseSource = parseSource.replace(toDatePattern, '');
      if (Date.parse(fromString))
        target.SearchDateEnd = this._momentService
          .getMomentByDate(new Date(fromString))
          .startOf('day')
          .toDate();
    }

    // set date defaults
    if (!target.SearchDateBegin) {
      if (Date.parse(this.defaultSearchDateStart)) target.SearchDateBegin = new Date(Date.parse(this.defaultSearchDateStart));
      // search for futre event by default
      else
        target.SearchDateBegin = this._momentService
          .getMomentByDate(new Date())
          .startOf('day')
          .toDate();
    }
    // set date defaults
    if (!target.SearchDateEnd) {
      if (Date.parse(this.defaultSearchDateEnd)) target.SearchDateEnd = new Date(Date.parse(this.defaultSearchDateStart));
      // search till the end of time by default
      else target.SearchDateEnd = new Date(2050, 0, 1, 0, 0, 0, 0);
    }

    target.Keyword = parseSource.trim();

    return target;
  }
}
